<template>
  <div class="assignments-table-wrapper">
    <div class="table-responsive profile-table assignment-table">
      <table class="table align-items-center">
        <thead>
        <tr>
          <th scope="col">{{ $t('general.training_name') }}</th>
          <th scope="col"> {{ $t('excel.heading.completion_date') }}</th>
          <th scope="col"> {{ $t('general.status') }} {{ $t('general.point') }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody v-if="assignments.length" class="list">
        <tr v-for="assignment in assignments" :key="assignment.id">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <p class="name h6 mb-0 text-sm">{{ assignment.name }}</p>
              </div>
            </div>
          </th>
          <td>
            <template v-if="assignment.is_completed">
              {{ formatDate(assignment.assignment_user_completed_at) }} / {{ $t('general.duration') }}: {{ assignment.assignment_user_duration }}
            </template>
            <template v-else-if="assignment.assignment_user_start_at">
              {{ $t('general.on_going') }}
            </template>
            <template v-else>
              -
            </template>
          </td>
          <td class="status-cell">
            <template v-if="getAssignmentStatus(assignment) === 'passive'">
                <span class="badge badge-danger status-badge">
                  <i class="uil-ban mr-1"></i>
                  {{ $t('general.passive') }}
                </span>
            </template>
            <template v-else-if="getAssignmentStatus(assignment) === 'not_started'">
                <span class="badge badge-secondary status-badge">
                  <i class="uil-hourglass mr-1"></i>
                  {{ $t('general.waiting') }}
                </span>
            </template>
            <template v-else-if="getAssignmentStatus(assignment) === 'start'">
                <span class="badge badge-info status-badge">
                  <i class="uil-play-circle mr-1"></i>
                  {{ $t('general.start') }}
                </span>
            </template>
            <template v-else-if="getAssignmentStatus(assignment) === 'continue'">
                <span class="badge badge-warning status-badge">
                  <i class="uil-clock"></i>
                  {{ $t('general.on_going') }} ({{ assignment.completed_contents_count }} / {{ assignment.total_contents_count }})
                </span>
            </template>
            <template v-else-if="getAssignmentStatus(assignment) === 'expired'">
                <span class="badge badge-danger status-badge">
                  <i class="uil-clock-three mr-1"></i>
                  {{ $t('general.expired') }}  ({{ assignment.completed_contents_count }} / {{ assignment.total_contents_count }})
                </span>
            </template>
            <template v-else-if="getAssignmentStatus(assignment) === 'watchagain'">
                <span class="badge badge-success status-badge">
                  <i class="uil-redo mr-1"></i>
                  {{ $t('general.completed') }} / {{ assignment.completed_contents_point }}
                </span>
            </template>
            <template v-else-if="getAssignmentStatus(assignment) === 'completed'">
                <span class="badge badge-success status-badge">
                  <i class="uil-check-circle mr-1"></i>
                  {{ $t('general.completed') }} / {{ assignment.completed_contents_point }}
                </span>
            </template>
          </td>
          <td class="text-right">
            <!-- Actions -->
            <div class="actions" v-if="getAssignmentStatus(assignment) !== 'passive'">
              <router-link :to="{ name: 'user.assignment-detail', params: { id: assignment.id } }"
                           class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.go_to_education')">
                <i class="uil-presentation"></i>
              </router-link>
              <router-link :to="{ name: 'company.assignments.add' }"
                           class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.reassign')">
                <i class="uil-location-arrow text-warning"></i>
              </router-link>

              <button class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.mark_as_completed')"
                      @click="$emit('openContentCompleteModal', assignment)">
                <i class="uil-check-circle text-success"></i>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="4" class="text-center py-4">
            {{ $t('general.no_assignments') }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination - Scroll dışında sabit -->
    <pagination
        v-if="assignmentsPagination && assignmentsPagination.last_page > 1"
        :pagination="assignmentsPagination"
        class="mt-2 mb-3"
        @changePage="$emit('changePage', $event)"
    ></pagination>
  </div>
</template>

<script>
import Pagination from "@/assets/components/Pagination.vue";
import { formatDate } from '@/utils/timeUtils.js';

export default {
  name: 'AssignmentsTable',
  components: {
    Pagination
  },
  props: {
    assignments: {
      type: Array,
      default: () => []
    },
    assignmentsPagination: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatDate,
    getAssignmentStatus(assignment) {
      // Pasif atama kontrolü
      if (assignment.status_id === false || assignment.status_id === 0) {
        return 'passive';
      }

      // Backend'den gelen action_label field'ına göre durum belirleme
      // Backend'deki olası değerler: not_started, start, continue, expired, watchagain, completed
      if (assignment.action_label) {
        return assignment.action_label;
      }

      // Fallback: Eğer action_label yoksa eski mantığı kullan
      if (assignment.is_completed) {
        return 'completed';
      }

      if (assignment.completed_contents_count > 0) {
        return 'continue';
      }

      return 'not_started';
    }
  }
}
</script>

<style scoped>
.assignments-table-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.table-responsive.profile-table {
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  border-radius: 8px 8px 0 0;
}

.table-responsive.profile-table table {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
  table-layout: fixed;
}

.table-responsive.profile-table thead {
  position: sticky;
  background-color: #f8f9fa;
}

.table-responsive.profile-table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  padding: 12px;
  text-align: left;
}

/* Sütun genişlikleri */
.table-responsive.profile-table thead th:nth-child(1),
.table-responsive.profile-table tbody td:nth-child(1) {
  width: 25%;
  min-width: 180px;
}

.table-responsive.profile-table thead th:nth-child(2),
.table-responsive.profile-table tbody td:nth-child(2) {
  width: 25%;
  min-width: 180px;
}

.table-responsive.profile-table thead th:nth-child(3),
.table-responsive.profile-table tbody td:nth-child(3) {
  width: 25%;
  min-width: 140px;
}

.table-responsive.profile-table thead th:nth-child(4),
.table-responsive.profile-table tbody td:nth-child(4) {
  width: 20%;
  min-width: 100px;
}

.btn-circle {
  width: 32px !important;
  height: 32px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}

.actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.status-cell {
  width: 200px;
}

.status-badge {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.status-badge i {
  font-size: 14px;
  margin-right: 4px;
  color: #fff !important;
}

/* Badge renkleri */
.badge-warning {
  background-color: #ffc107;
  color: #000;
}

.badge-warning i {
  color: #000 !important;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}

.badge-info {
  background-color: #17a2b8;
  color: #fff;
}

.badge-danger {
  background-color: #dc3545;
  color: #fff;
}

@media (max-width: 960px) {
  .assignments-table-wrapper {
    height: auto;
  }

  .status-cell {
    width: auto;
  }

  .status-badge {
    min-height: 44px;
    padding: 10px 12px;
    font-size: 14px;
    white-space: normal;
  }

  .table-responsive.profile-table {
    height: auto;
    max-height: none;
    border-radius: 14px 14px 0 0;
  }

  .table-responsive.profile-table table {
    min-width: 560px;
  }
}
</style>

